// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"styles_Checkbox__FLcPe","Checkbox--column":"styles_Checkbox--column__1JQQW"};